<template>
  <div class="function-edit">
    <p class="page-title">{{`${$route.params.id === '0' ? `新建` : `编辑`}`}}</p>
    <el-button class="pull-right" type="primary" plain size="mini" @click.prevent="cancel()"><i class="el-icon-back"></i>返回</el-button>
    <div class="page-card">
      <div class="page-section">
        <el-form ref="form" :model="this" :rules="rules" label-width="100px" :inline="true" class="demo-form-inline mt25">
          <el-form-item label="id" prop="id">
            <el-input :disabled="$route.params.id !== '0'" class="input100" v-model="id" :placeholder="`请输入`"></el-input>
          </el-form-item>
          <el-form-item :label="`状态`" prop="status">
            <el-radio-group class="input200" v-model="status">
              <el-radio :label="1">打开</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="`名称`" prop="name">
            <el-input class="input200" v-model="name" :placeholder="`请输入`" type="textarea" :rows="10" :maxlength="100" :show-word-limit="true"></el-input>
          </el-form-item>
          <el-form-item :label="`描述`" prop="remark">
            <el-input class="input200" v-model="remark" type="textarea" :placeholder="`请输入`" :rows="10" :maxlength="100" :show-word-limit="true"></el-input>
          </el-form-item>
        </el-form>
        <div class="mt10">
          <el-button size="small" type="primary" @click="save()">保存</el-button>
          <el-button size="small" @click="cancel()">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { functionEdit, functionDetail } from '@/api.js'
export default {
  name: 'rules',
  data() {
    return {
      id: '',
      name: '',
      status: 0,
      remark: '',
      pageId: 0,
      rules: {
        id: [
          { required: true, message: `请输入`, trigger: 'blur' }
        ],
        name: [
          { required: true, message: `请输入`, trigger: 'blur' }
        ],
        status:[
          { required: true, message: `请选择`, trigger: 'blur' }
        ],
        remark: [
          { required: true, message: `请输入`, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.pageId = Number(this.$route.params.id)
    if (this.pageId) {
      this.getDetail(this.pageId)
    }
  },
  methods: {
    async getDetail(id) {
      // 获取详情
      const url = functionDetail.replace('{id}', id)
      const res = await this.$request('get', url, {})
      if (res) {
        const { name, remark, status, id } = res
        this.id = id
        this.name = name
        this.status = status
        this.remark = remark
      }
    },
    save() {
      const url = functionEdit.replace('{id}', this.pageId)
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.$message.error(`请填写必填项`)
          
          return
        }

        const { id, name, status, remark } = this
        const isNew = !this.pageId
        const info = {
          id,
          name,
          remark,
          status
        }
        const res = await this.$request('post', url, info)
        if (res) {
          this.$message.success(isNew ? `新增成功` : `修改成功`)
          this.cancel()
        }
      })
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
  .function-edit {
    position: relative;
  }
</style>

